import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=ffde0f16&scoped=true&"
import script from "./HomeFooter.vue?vue&type=script&lang=ts&"
export * from "./HomeFooter.vue?vue&type=script&lang=ts&"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=ffde0f16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffde0f16",
  null
  
)

export default component.exports